import * as React from 'react';

export function CheckboxFacet(props) {
  const {label, options, onSelect, onRemove, initialFacetValues = [], isFirstFacet = false} = props;

  // Auto-deselect for subsequent facets — mirrors Typesense CustomRefinementList logic
  React.useEffect(() => {
    if (isFirstFacet) return;

    options.forEach(option => {
      if (option.selected && option.count === 0) {
        onRemove(option.value);
      }
    });
  }, [options, isFirstFacet]);

  const merged = React.useMemo(() => {
    const existing = new Map(options.map(o => [o.value, o]));
    const missing = initialFacetValues
      .filter(v => !existing.has(v))
      .map(v => ({value: v, count: 0, selected: false}));
    return [...options, ...missing].sort((a, b) => String(a.value).localeCompare(String(b.value)));
  }, [options, initialFacetValues]);

  return (
    <fieldset>
      <legend>{label}</legend>
      {merged.map(option => {
        const disabled = !isFirstFacet && option.count === 0;
        return (
          <label key={option.value} className={disabled ? 'disabled' : ''}>
            <input
              type="checkbox"
              checked={option.selected}
              data-checked={option.selected}
              disabled={disabled}
              onChange={() => {
                option.selected ? onRemove(option.value) : onSelect(option.value);
              }}
            />
            <span>{option.value} <span className='counter'>({option.count})</span></span>
          </label>
        );
      })}
    </fieldset>
  );
}
